// src/services/auth.service.js
import api from "./api";

export const registerAdmin = (payload) =>
  api.post("/auth/admin/register", payload);

export const login = async (payload) => {
  const data = await api.post("/auth/login", payload);

  // Save auth info
  localStorage.setItem("user", JSON.stringify(data));
  localStorage.setItem("access_token", data.token || "");

  return data;
};

export const logout = () => {
  localStorage.clear();
};
